import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const state = {
    totals: [],
    chargeTotals: null,
    isTPPWidgetVisible: false,
    oneYearPeriods: [],
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
